module.exports = __webpack_public_path__ + "img/101ne.59115314.svg";